// @flow

import URLSearchParams from '@ungap/url-search-params';
import type { UserInputValues } from '@tectonics/prs/user-input-values';
import { extractCardBin } from '@tectonics/commons/card';
import { getAmountExt } from '@tectonics/prs/receipts';
import { getCountry, getMerchant, getReceipts, type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { getPublicIntegrationKey } from '@tectonics/prs/merchant';
import type { ApiInstalment } from './types';

export async function getInstalmentsPlanFromApi(
  incomingPayment: IncomingPayment,
  userInputValues: UserInputValues
): Promise<ImmutableArray<ApiInstalment>> {
  const params = buildQueryParams(incomingPayment, userInputValues);
  const url = `${ENV_CONSTANTS.EBANX_API_BASE_URL}ws/instalmentsPlan?${params.toString()}`;

  const response = await fetch(url);
  const { instalmentsPlan, code, error } = await response.json();

  if (!instalmentsPlan) {
    throw new Error(`fetchInstalmentsPlanFromApi - ${code} ${error}`);
  }

  return instalmentsPlan;
}

function buildQueryParams(incomingPayment: IncomingPayment, userInputValues: UserInputValues): URLSearchParams {
  const country_abbreviation = getCountry(incomingPayment);

  const receipts = getReceipts(incomingPayment);
  const [currency_code, amount] = getAmountExt(receipts);

  const bin = extractCardBin(userInputValues['cardNumber']);

  const merchant = getMerchant(incomingPayment);
  const public_key = getPublicIntegrationKey(merchant);

  return new URLSearchParams({
    amount,
    bin,
    country_abbreviation,
    currency_code,
    public_key,
  });
}
